import { Repository } from './Repository';

let cachedRate: number | null = null;
let cachedCurrencyCode: string | null = null;

export class ExchangeRateRepository extends Repository {
  getCachedExchangeRateForSat(currencyCode: string): number | null {
    if (cachedCurrencyCode === currencyCode && cachedRate !== null) {
      return cachedRate;
    }
    return null;
  }

  async preloadExchangeRateCache(currencyCode: string): Promise<void> {
    try {
      await this.getExchangeRateForSat(currencyCode);
    } catch (error) {
      console.error('Error preloading exchange rate cache', error);
    }
  }

  /**
   * Fetch the exchange rate for 1 satoshi in the given currency.
   * Very simple cache: per-session, per-currencyCode.
   */
  async getExchangeRateForSat(currencyCode: string): Promise<number> {
    if (cachedRate !== null && cachedCurrencyCode === currencyCode) {
      return cachedRate;
    }

    const path = `/v1/exchange-rate/${encodeURIComponent(currencyCode)}`;
    const response = await Repository.client.get(path);

    const rate = response.data.data.rate as number;
    cachedRate = rate;
    cachedCurrencyCode = currencyCode;

    return rate;
  }
}

// Singleton instance
export const exchangeRateRepository = new ExchangeRateRepository();

